import { mapState } from 'vuex';

import { useDialog, useFormWithRef, useStateFlag } from '@mixins/factories';

import { Validator, wrapToLoadingFn } from '@helpers';

import { namespace as ApplicationsNamespace } from '../../store.type';

import ApplicationsApiService from '../../_services/applications.api.service';

const validator = Validator.createValidator({
  role: ['required', { rule: 'alreadyTaken', value: [] }],
});

const headers = Object.freeze([
  { text: 'Name', value: 'name' },
]);

export default {
  name: 'UmsApplicationRoles',
  props: {
    app: {
      type: String,
      default: '',
    },
  },
  mixins: [
    useDialog(),
    useFormWithRef(),
    Validator.useValidator(validator),
    useStateFlag('isCreateRoleLoading', false),
    useStateFlag('isUpdateRoleLoading', false),
  ],
  data: () => ({
    headers,
    role: '',
    editableRole: '',
    editableRoleIndex: null,
  }),
  computed: {
    ...mapState(ApplicationsNamespace, {
      roles({ applications: items }) {
        const { roles = [] } = items.find(({ name }) => name === this.app) || {};
        return roles;
      },
    }),
    title() {
      return `Roles for application ${this.app}`;
    },
    tableItems() {
      const { roles } = this;
      return roles.map((name) => ({ name }));
    },
    isInvalidEditableRole() {
      const rules = validator.getRulesByField('role');
      return rules.some((v) => typeof v(this.editableRole) === 'string');
    },
  },
  watch: {
    roles: {
      handler(newValue) {
        validator.updateFieldRule(
          'role',
          { rule: 'alreadyTaken', value: newValue },
        );
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    wrapToLoadingFn,
    setEditableRole({ __rowIndex, name }) {
      this.editableRole = name;
      this.editableRoleIndex = __rowIndex;
    },
    cancelEditing() {
      this.editableRole = '';
      this.editableRoleIndex = null;
    },
    createRole() {
      if (!this.isValidForm) {
        return;
      }

      this.wrapToLoadingFn({
        req: ApplicationsApiService.createRole.bind({}, { app: this.app, role: this.role }),
        loadingFlagName: 'isCreateRoleLoading',
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('Role successfully created');
          this.$_resetFormAndValidation();
          this.$emit('success');
        },
      });
    },
    updateRole(oldRole) {
      if (this.isInvalidEditableRole) {
        return;
      }

      this.wrapToLoadingFn({
        req: ApplicationsApiService.updateRole.bind({}, {
          oldRole,
          app: this.app,
          newRole: this.editableRole,
        }),
        loadingFlagName: 'isUpdateRoleLoading',
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('Role successfully updated');
          this.$emit('success');
          this.cancelEditing();
        },
      });
    },
  },
};
